import React, { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";
import toastr from "toastr";
import Decline from "../IncidentManagement/DeclinePopup";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";

import {
  getAllEventSchedules,
  getEventScheduleById,
  updateEventScheduleDetails,
} from "app/_services/ehs/ehsEventScheduleServices";
import { DepartmentService } from "app/_services/UserManagement/DepartmentService";
import DatePicker from "app/Components/DateTimeCustom/CustomDateTime";
import { UserService } from "app/_services/UserService/UserService";
import { Validation } from "app/_helpers/validation/Validation";
import { evidenceRules } from "../IncidentManagement/CONSTANTS";
import { initialEvidence, initialForm } from "./CONSTANT";
import EventInfo from "./EventInfo";
import MeetingEvidences from "./MeetingEvidences";
import { CommmonService } from "app/_services/CommonService/CommonService";
import {
  capitalizeName,
  employeeDropdownLabel,
  normalizeDateTime,
  userDropdownLabel,
} from "app/_helpers/helper";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";
import MeetingTimeline from "./Component/MeetingTimeline";
import MultiSelectWithCheckbox from "app/Components/SearchableSelect/MultiSelectCkeckOption";

import InputError from "app/Components/_form/InputError/InputError";
import ViewComments from "../IncidentManagement/ViewComments";
import MultiSelectTwo from "app/Components/SearchableSelect/MultiSelectTwo";

const EditMeetingDetails = ({
  match: {
    params: { id, siteId },
  },
  history,
}) => {
  const [form, setForm] = useState({ ...initialForm });
  const [formErrors, setFormErrors] = useState({ ...initialForm });
  const [tab, setTab] = useState(1);
  const [evidences, setEvidences] = useState([]);
  const [capas, setCapas] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [users, setUsers] = useState([]);
  const [participants, setParticipants] = useState([]);
  const [templatesForm, setTemplatesForm] = useState([]);
  // const [taskDrop, setTaskDrop] = useState({ ...taskFormat });
  const [taskDetailsErrors, setTaskDetailsErrors] = useState([]);
  const [taskDetails, setTaskDetails] = useState([{ ...taskFormat }]);
  const [evidencesErrors, setEvidencesErrors] = useState([]);
  const [viewAndEdit, setViewAndEdit] = useState("");
  const [getSchedule, setGetSchedule] = useState([]);
  // const [taskHoldArr, setTaskHoldArr] = useState([]);

  const rules = [
    {
      field_name: "comment",
      label: "Describe Comment",
      type: "string",
      isRequired: false,
    },
    {
      field_name: "meetingSummary",
      label: "Meeting Summary",
      type: "string",
      isRequired: tab === 3 ? true : false,
    },
  ];

  useEffect(() => {
    getAllEventSchedules().then((response) => {
      setGetSchedule(response?.data);
    });
  }, []);

  // --------------add more

  const onChange = ({ target: { name, type, checked, value } }) => {
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const Buttons = ({ tab, setTab, lastTab, onSubmit, siteId }) => (
    <div className="stepperFormButtons">
      {tab > 1 && (
        <span className="pointer btn btn-left" onClick={() => setTab((prev) => prev - 1)}>
          <BsArrowLeft /> Back
        </span>
      )}
      {tab < lastTab && (
        <span
          className="pointer btn btn-right"
          onClick={() => {
            // onSubmit(false, true);
            setTab((prev) => prev + 1);
          }}
        >
          Next
          <BsArrowRight />
        </span>
      )}

      {tab === lastTab && (
        <>
          {form?.isProgress ? (
            <Decline
              onSubmit={(obj) => onSubmit(true, "backward", obj)}
              title="Approve"
              name={<span className="pointer btn btn-right">Back to Scheduler</span>}
              iconClass={"icons text-success"}
            />
          ) : (
            <span
              onClick={() => onSubmit(true, "stay")}
              className="pointer btn btn-right"
            >
              Save
            </span>
          )}

          <span
            onClick={() => onSubmit(false, "forward")}
            className="pointer btn btn-right"
          >
            Send for Approve
          </span>
        </>
      )}
    </div>
  );

  const onChangeParticipant = ({ target: { name, type, checked, value } }, index) => {
    setParticipants((prev) =>
      prev.map((user, idx) => {
        if (idx !== index) return user;

        user[name] = type === "checkbox" ? checked : value;

        return user;
      })
    );
  };

  const onChangeTaskDetails = (
    { target: { name, type, checked, value, valueType } },
    index
  ) => {
    setTaskDetails((prev) =>
      prev.map((user, idx) => {
        if (idx !== index) return user;

        valueType === true
          ? (user[name] = type === "checkbox" ? checked : [value])
          : (user[name] = type === "checkbox" ? checked : value);

        return user;
      })
    );
  };

  const addEvidence = () =>
    setEvidences((previous) => [
      ...previous,
      { ...initialEvidence, incidentDetailsId: id },
    ]);

  const deleteEvidence = (index) =>
    setEvidences((previous) =>
      previous
        .map((data, idx) =>
          idx !== index ? data : data.id ? { ...data, deleted: 1 } : null
        )
        .filter((data) => !!data)
    );
  const onChangeEvidence = ({ name, value, type, checked, index }) => {
    setEvidences((prevEvidences) =>
      prevEvidences.map((data, idx) => {
        if (idx !== index) return data;

        data[name] = type === "checkbox" ? checked : value;
        return data;
      })
    );
  };
  const onChangeEvidenceFile = ({ responseData, index }) => {
    setEvidences((prevEvidences) =>
      prevEvidences.map((data, idx) => {
        if (idx !== index) return data;

        data.file = responseData;
        data.fileId = responseData.id;

        return data;
      })
    );
  };

  const onSubmit = async (completed, submitStatus, obj) => {
    let flag = 0;
    const errorObj = Validation(form, rules);
    if (form?.id && !form.reviewCompletionSummary) {
      errorObj.reviewCompletionSummary = "Message is Required";
    }
    // const taskErrors = taskDetails.map((task) => Validation(task, taskDetailRule));

    const taskErrors = taskDetails.map((task) => {
      return Validation(
        { ...task, taskDescription: task.taskDescription.toString().trim() },
        taskDetailRule
      );
    });
    const evidenceErrors = evidences.map((evidence) =>
      Validation(evidence, evidenceRules)
    );

    // if (!errorObj.actualDate && new Date(form.date).getTime() > new Date(form.actualDate))
    //   errorObj.actualDate = "Date can not be before Event Date Time.";

    setFormErrors(errorObj);
    setTaskDetailsErrors(taskErrors);

    setEvidencesErrors(evidenceErrors);

    for (const key in errorObj) if (errorObj[key]) flag = 1;
    for (const obj of taskErrors) for (const key in obj) if (obj[key]) flag = 1;
    for (const obj of evidenceErrors) for (const key in obj) if (obj[key]) flag = 1;

    console.log("flag", flag);
    console.log("errorObj", errorObj);
    console.log("taskErrors", taskErrors);
    console.log("evidenceErrors", evidenceErrors);
    console.log("taskDetails", taskDetails);
    if (flag !== 0 && !completed)
      return toastr.warning("Please complete all required fields.");

    const data = {
      meetingSummary: form.meetingSummary,
      tasks: taskDetails,
      comment: obj?.comment,

      evidences,
      participants: participants.map((p) => ({
        attended: p.attended,
        id: p.id,
      })),
      actualDate: form.actualDate,
      moveMeeting: submitStatus,
      isTaskRequired: 1,
      reviewCompletionSummary: form.reviewCompletionSummary,
    };
    console.log("being submitted");
    // return;
    const response = await updateEventScheduleDetails(id, data);

    if (!response?.status) {
      return toastr.error(response.message);
    }

    toastr.success(response.message);
    history.push(
      (siteId ? `/sites/${siteId}` : "") +
        "/health-safety-and-environment/audits-meetings"
    );
  };

  const addRow = () => {
    setTaskDetails((prev) => [...prev, { ...taskFormat }]);
  };

  const deleteRow = (index) => {
    setTaskDetails((previous) =>
      previous
        .map((data, idx) =>
          idx !== index ? data : data?.id ? { ...data, deleted: 1 } : null
        )
        .filter((data) => !!data)
    );
  };
  console.log("rrrrrrrrrrrrr", taskDetails);

  const url = useLocation();
  useEffect(() => {
    setViewAndEdit(url.pathname);
    DepartmentService.getDepartment("filter[status]=1").then((response) => {
      if (!response?.data) return;

      setDepartments(response.data.departments);
    });
    UserService.getUsers("filter[status]=1").then((response) => {
      if (!response?.data) return;

      setUsers(response.data);
    });
  }, []);

  useEffect(() => {
    getEventScheduleById(id).then((response) => {
      if (!response?.data) return;

      setForm({
        ...response.data,
        actualDate: normalizeDateTime(response.data.actualDate),
      });

      setParticipants(response.data.participants);
      setEvidences(response.data.evidences);
      setTaskDetails(
        response.data.tasks.map((d) => ({
          ...d,
          taskOwners: d?.taskOwners.map((d) => d.ownerId),
        }))
      );
    });
  }, [id]);

  // useEffect(() => {
  //   setForm((prev) => ({
  //     ...prev,
  //     tasks: taskDetails,
  //   }));
  // }, [taskDetails]);

  // console.log("taskDetails", taskDetails);

  // console.log("viewAndEdit", viewAndEdit);

  // console.log("aaa", viewAndEdit.includes("view"));

  const viewPage = useMemo(() => viewAndEdit.includes("view"), [viewAndEdit]);

  let holdIndex;
  return (
    <>
      {viewAndEdit.includes("view") ? (
        <MainBreadcrumb
          routeSegments={[
            { name: "Health Safety And Environment", path: "#" },
            {
              name: "OHSE Review",
              path: "/health-safety-and-environment/audits-meetings",
            },
            {
              name: "View",
            },
          ]}
        />
      ) : (
        <MainBreadcrumb
          routeSegments={[
            { name: "Health Safety And Environment", path: "#" },
            {
              name: "OHSE Review",
              path: "/health-safety-and-environment/audits-meetings",
            },
            // {
            //   name: "My Approval Actions",
            //   path: "/health-safety-and-environment/audits-meetings/my-approval",
            // },
            {
              name: "Edit",
            },
          ]}
        />
      )}
      <div className="healthSafetyEnvironmentWrapper EHS_module_tabber">
        <div className="hseMenuLinks card">
          <a
            href
            className={`pointer${tab === 1 ? " active" : ""}`}
            onClick={() => setTab(1)}
          >
            Timeline
          </a>
          <a
            href
            className={`pointer${tab === 2 ? " active" : ""}`}
            onClick={() => setTab(2)}
          >
            Participants Attendance
          </a>
          <a
            href
            className={`pointer${tab === 3 ? " active" : ""}`}
            onClick={() => setTab(3)}
          >
            MOM
          </a>
          <a
            href
            className={`pointer${tab === 4 ? " active" : ""}`}
            onClick={() => setTab(4)}
          >
            Documents
          </a>
          <a
            href
            className={`pointer${tab === 5 ? " active" : ""}`}
            onClick={() => setTab(5)}
          >
            Task
          </a>
          <a
            href
            onClick={() => setTab(6)}
            className={`pointer${tab === 6 ? " active" : ""}`}
          >
            Workflow Inputs
          </a>
        </div>
      </div>
      <Row>
        {tab === 1 && (
          <Col lg={9}>
            <MeetingTimeline form={form} />
          </Col>
        )}
        {tab === 2 && (
          <>
            <Col lg={9}>
              <div className="card p-3 pb-0 mt-4 EHS_module_create_form">
                <div className="simple-card-title">
                  <h3 className="text-capitalize mb-0">Attendance</h3>
                  {/* <BackBtn /> */}
                </div>

                {form?.isProgress || viewPage ? (
                  <div className="form-group viewbox">
                    <div className="table-responsive">
                      <table id="user_table" className="table table-bordered mb-3">
                        <thead>
                          <tr>
                            <th scope="col">S.No</th>
                            <th scope="col">Participant Category</th>
                            <th scope="col">Participant Name</th>
                            <th scope="col">Participant Email</th>
                            <th scope="col">Participant Attendance</th>
                          </tr>
                        </thead>
                        <tbody>
                          {participants.map((user, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{user.category}</td>
                              <td>{capitalizeName(user.name)}</td>
                              <td>{user.email}</td>
                              <td>{user.attended}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div className="ehsFormWrapper">
                    <div className="w-100">
                      <div className="table-responsive drillingPlan-plannedEdit">
                        <table id="user_table" className="table table-bordered mb-3">
                          <thead>
                            <tr>
                              <th scope="col">S.No.</th>
                              <th scope="col">Invited Attendees</th>
                              <th scope="col">Attendees Email</th>
                              <th scope="col">Attendance</th>
                            </tr>
                          </thead>
                          <tbody>
                            {participants.map((user, index) => (
                              <tr key={index}>
                                <th>{index}</th>
                                <td>
                                  <p>{user.name}</p>
                                </td>
                                <td>
                                  <p>{user.email}</p>
                                </td>
                                <td>
                                  <div className="d-flex">
                                    <div className="mr-4">
                                      <label className="radio radio-primary form-check-inline">
                                        <input
                                          type="radio"
                                          disabled={form?.isProgress ? true : false}
                                          name={"attended-" + index}
                                          value="Yes"
                                          checked={user.attended === "Yes"}
                                          onChange={({ target: { value } }) =>
                                            onChangeParticipant(
                                              {
                                                target: {
                                                  name: "attended",
                                                  value,
                                                },
                                              },
                                              index
                                            )
                                          }
                                        />
                                        <span className="ml-n1">Yes</span>
                                        <span className="checkmark"></span>
                                      </label>
                                    </div>
                                    <div className="">
                                      <label className="radio radio-primary form-check-inline">
                                        <input
                                          type="radio"
                                          name={"attended-" + index}
                                          value="No"
                                          disabled={form?.isProgress ? true : false}
                                          checked={user.attended === "No"}
                                          onChange={({ target: { value } }) =>
                                            onChangeParticipant(
                                              {
                                                target: {
                                                  name: "attended",
                                                  value,
                                                },
                                              },
                                              index
                                            )
                                          }
                                        />
                                        <span className="ml-n1">No</span>
                                        <span className="checkmark"></span>
                                      </label>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
                {viewAndEdit.includes("view") ? (
                  ""
                ) : (
                  <Buttons
                    tab={tab}
                    setTab={setTab}
                    lastTab={6}
                    siteId={siteId}
                    onSubmit={onSubmit}
                  />
                )}
              </div>
            </Col>
          </>
        )}
        {tab === 3 && (
          <Col lg={9}>
            <div className="card p-3 pb-0 mt-4 EHS_module_create_form">
              <div className="ehsFormWrapper">
                <div className="simple-card-title">
                  <h3>Meeting Summary</h3>
                  {/* <BackBtn /> */}
                </div>

                <div className="form-group viewbox">
                  {/* <h5 className="w-500 mb-1">Meeting Summary</h5> */}

                  {form?.isProgress || viewPage ? (
                    <p>{form?.meetingSummary}</p>
                  ) : (
                    <>
                      {" "}
                      <textarea
                        className="form-control h-120"
                        disabled={form?.isProgress ? true : false}
                        name="meetingSummary"
                        value={form.meetingSummary}
                        onChange={onChange}
                      />
                      <span className="small text-danger">
                        {formErrors.meetingSummary}
                      </span>
                    </>
                  )}
                </div>
              </div>
              {viewAndEdit.includes("view") ? (
                ""
              ) : (
                <Buttons
                  tab={tab}
                  setTab={setTab}
                  lastTab={6}
                  siteId={siteId}
                  onSubmit={onSubmit}
                />
              )}
            </div>
          </Col>
        )}
        {tab === 4 && (
          <Col lg={9}>
            <div className="card p-3 pb-0 mt-4 EHS_module_create_form">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">Document</h3>
                {/* <BackBtn /> */}
              </div>
              <div className="ehsFormWrapper">
                <div className="w-100">
                  {form?.isProgress || viewPage ? (
                    <div className="table-responsive">
                      <table id="user_table" className="table table-bordered mb-3">
                        <thead>
                          <tr>
                            <th scope="col">S.No</th>
                            <th scope="col">Category</th>
                            <th scope="col">File View</th>
                          </tr>
                        </thead>
                        <tbody>
                          {form?.evidences?.map((doc, index) => (
                            <tr key={index}>
                              <td style={{ width: "32%" }}>{index + 1}</td>
                              <td style={{ width: "34%" }}>{doc.type}</td>
                              <td style={{ width: "34%" }}>
                                <img
                                  src={`${URL_CONFIG.DEV_URL}/uploads/${doc?.file?.document_name}`}
                                  alt="img-1"
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <MeetingEvidences
                      dataArray={evidences}
                      errorArray={evidencesErrors}
                      onChange={onChangeEvidence}
                      onAdd={addEvidence}
                      onDelete={deleteEvidence}
                      onChangeFile={onChangeEvidenceFile}
                    />
                  )}
                </div>
              </div>
              {viewAndEdit.includes("view") ? (
                ""
              ) : (
                <Buttons
                  tab={tab}
                  setTab={setTab}
                  lastTab={6}
                  siteId={siteId}
                  onSubmit={onSubmit}
                />
              )}
            </div>
          </Col>
        )}
        {tab === 5 && (
          <Col lg={9}>
            <div className="card p-3 pb-0 mt-4 EHS_module_create_form overflow-visible">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">Task</h3>
                {/* <BackBtn /> */}
              </div>
              <div className="ehsFormWrapper">
                <div className="w-100">
                  <Row className="mb-3">
                    {form?.isProgress || viewPage ? (
                      <Col lg={12}>
                        <div className="form-group viewbox">
                          <h5 className="w-500 mb-1">Participants</h5>
                          <div className="table-responsive">
                            <table id="user_table" className="table table-bordered mb-3">
                              <thead>
                                <tr>
                                  <th scope="col">S.No</th>
                                  <th scope="col">ID</th>
                                  <th scope="col">Task Description</th>
                                  <th scope="col">Task Due Date</th>
                                  <th scope="col">Task Owners Count</th>
                                  <th scope="col">Task Owners</th>
                                  <th scope="col">Task Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                {form?.tasks?.map((data, index) => (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{data.id}</td>
                                    <td>{data.taskDescription}</td>
                                    <td>{data.taskDueDate}</td>
                                    <td>{data.taskOwnersCount}</td>
                                    <td>
                                      {data?.taskOwners.map((data) => (
                                        <tr>
                                          <td
                                            style={{ width: "100%" }}
                                          >{`${data.userData.firstName} ${data.userData.lastName}`}</td>
                                        </tr>
                                      ))}
                                    </td>
                                    <td>
                                      {data?.taskOwners.map((data) => (
                                        <tr>
                                          <td style={{ width: "100%" }}>{`${
                                            +data.isTaskCompleted === 1
                                              ? "Completed"
                                              : "Open"
                                          }`}</td>
                                        </tr>
                                      ))}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col>
                    ) : (
                      <Col lg={12}>
                        <div className="form-group viewbox">
                          {/* <h5 className="w-500 mb-1">Task</h5> */}
                          <div className="w-100">
                            <div className="table-responsive">
                              <table
                                id="user_table"
                                className="table table-bordered mb-3"
                              >
                                <thead>
                                  <tr>
                                    <th scope="col">S.No</th>
                                    <th scope="col">Task Description</th>
                                    <th scope="col">Task Due Date</th>
                                    <th scope="col">Task Owners Count</th>
                                    <th scope="col">Task Owners</th>
                                    <th scope="col">Remove</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {taskDetails?.map((value, index) => {
                                    holdIndex = index + 1;
                                    return value.deleted ? null : (
                                      <tr key={index}>
                                        <th>{holdIndex}</th>
                                        <td>
                                          <input
                                            name="taskDescription"
                                            disabled={form?.isProgress ? true : false}
                                            className="form-control"
                                            onChange={({ target: { value } }) =>
                                              onChangeTaskDetails(
                                                {
                                                  target: {
                                                    name: "taskDescription",
                                                    value,
                                                  },
                                                },
                                                index
                                              )
                                            }
                                            value={
                                              form?.tasks[index]?.taskDescription
                                                ? form?.tasks[index]?.taskDescription
                                                : taskDetails[index]?.taskDescription
                                            }
                                          />
                                          <span className="small text-danger">
                                            {/* {taskDetailsErrors.meetingSummary} */}
                                          </span>
                                        </td>

                                        <td>
                                          <DatePicker
                                            name="taskDateDue"
                                            // timeFormat={"HH:mm:ss"}
                                            value={
                                              form?.tasks[index]?.taskDueDate
                                                ? form?.tasks[index]?.taskDueDate
                                                : taskDetails[index]?.taskDueDate
                                            }
                                            disabled={form?.isProgress ? true : false}
                                            isValidDate={(m) => m.isAfter(new Date())}
                                            readOnly={true}
                                            onChange={(moment, name) => {
                                              value =
                                                moment.format("YYYY-MM-DD HH:mm:ss");
                                              onChangeTaskDetails(
                                                {
                                                  target: {
                                                    name: "taskDueDate",
                                                    value,
                                                  },
                                                },
                                                index
                                              );
                                            }}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            disabled={form?.isProgress ? true : false}
                                            name="taskOwnersCount"
                                            className="form-control"
                                            value={
                                              form?.tasks[index]?.taskOwnersCount
                                                ? form?.tasks[index]?.taskOwnersCount
                                                : taskDetails[index]?.taskOwnersCount
                                            }
                                            readOnly={true}
                                            onChange={({ target: { value } }) =>
                                              onChangeTaskDetails(
                                                {
                                                  target: {
                                                    name: "taskOwnersCount",
                                                    value,
                                                  },
                                                },
                                                index
                                              )
                                            }
                                          />
                                        </td>
                                        <td>
                                          <MultiSelectTwo
                                            // disabled={form?.eventStatus=="inProgress"?true:false}
                                            options={users.map((user) => ({
                                              label: userDropdownLabel(user),
                                              value: user.id,
                                              disabled: !taskDetails[index]?.taskOwners
                                                ? false
                                                : taskDetails[index]?.taskOwners
                                                    ?.length === 20 &&
                                                  taskDetails[
                                                    index
                                                  ]?.taskOwners?.includes(user.id)
                                                ? false
                                                : taskDetails[index]?.taskOwners?.length <
                                                    20 ||
                                                  taskDetails[index]?.taskOwners
                                                    ?.length === 0
                                                ? false
                                                : true,
                                            }))}
                                            value={users
                                              .filter((user) =>
                                                taskDetails[index]?.taskOwners?.includes(
                                                  user.id
                                                )
                                              )
                                              .map((user) => ({
                                                label: userDropdownLabel(user),
                                                value: user.id,
                                              }))}
                                            onChange={(e) => {
                                              setTaskDetails((prev) => {
                                                let obj = JSON.parse(
                                                  JSON.stringify(prev)
                                                );
                                                obj[index].taskOwners = e?.map(
                                                  (d) => d.value
                                                );
                                                obj[index].taskOwnersCount =
                                                  obj[index].taskOwners?.length;
                                                return obj;
                                              });

                                              // setTaskDetails((prev)=>({
                                              //   ...prev[index],
                                              //   taskOwnersCount:prev[index].taskOwners.length
                                              // }))
                                            }}
                                            hasSelectAll={false}
                                          />
                                        </td>
                                        <td>
                                          <div className="actionIconsGroup">
                                            <CustomTooltip tooltip="Delete">
                                              <span
                                                onClick={() => deleteRow(index)}
                                                className="pointer icons text-danger font-20"
                                              >
                                                <FiMinusCircle />
                                              </span>
                                            </CustomTooltip>
                                          </div>
                                        </td>
                                      </tr>
                                    );
                                  })}

                                  <tr>
                                    <td colSpan="10">
                                      <CustomTooltip tooltip="Add Row">
                                        <Button
                                          onClick={addRow}
                                          className="addRowPluseIcon"
                                        >
                                          <FiPlusCircle />
                                        </Button>
                                      </CustomTooltip>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </Col>
                    )}
                  </Row>
                </div>
              </div>
              {viewAndEdit.includes("view") ? (
                ""
              ) : (
                <Buttons
                  tab={tab}
                  setTab={setTab}
                  lastTab={6}
                  siteId={siteId}
                  onSubmit={onSubmit}
                />
              )}
            </div>
          </Col>
        )}
        {tab === 6 && (
          <Col lg={9} className="pt-3">
            <ViewComments comments={form?.incidentReviewsData || []} />

            {!viewAndEdit.includes("view") && (
              <div className="addReviewerInput">
                <textarea
                  class="form-control"
                  style={{ height: "88px" }}
                  name="reviewCompletionSummary"
                  onChange={onChange}
                  value={form.reviewCompletionSummary}
                  maxLength={500}
                  placeholder={`${
                    form?.vflAtLabel !== "so" ? "Mines Manager " : "Safety Officer "
                  } Input`}
                />
                {formErrors["reviewCompletionSummary"] && (
                  <InputError error={formErrors["reviewCompletionSummary"]} />
                )}
              </div>
            )}

            {viewAndEdit.includes("view") ? (
              ""
            ) : (
              <Buttons
                tab={tab}
                setTab={setTab}
                lastTab={6}
                siteId={siteId}
                onSubmit={onSubmit}
              />
            )}
          </Col>
        )}
        <Col lg={3}>
          <EventInfo form={form} getSchedule={getSchedule} />
        </Col>
      </Row>
    </>
  );
};

const taskFormat = {
  id: "",
  taskDescription: "",
  taskDueDate: "",
  taskOwners: [],
  taskOwnersCount: "",
};

const taskDetailRule = [
  {
    field_name: "taskDescription",
    type: "String",
    isRequired: false,
  },
  {
    field_name: "taskDateDue",
    type: "String",
    isRequired: false,
  },
  {
    field_name: "taskOwners",
    type: "String",
    isRequired: false,
  },
  {
    field_name: "taskOwnersCount",
    type: "String",
    isRequired: false,
  },
];

export default EditMeetingDetails;
